import React, { cloneElement } from 'react';
import { FlatButton, RaisedButton } from 'material-ui';
import R from 'ramda';

export const JiraFlatButton = ({ labelStyle, ...extraProps }) => (
  <SmallFlatButton
    labelStyle={R.merge({ color: extraProps.secondary || extraProps.primary ? '' : '#5E6C84' }, labelStyle)}
    backgroundColor="#f4f5f7"
    {...extraProps}
  />
);

export const SmallFlatButton = ({ style, labelStyle, icon, ...extraProps }) => (
  <FlatButton
    labelStyle={R.merge({ textTransform: 'none', padding: '2px 4px', lineHeight: '24px', fontSize: '14px' }, labelStyle)}
    style={R.merge({ height: '24px', lineHeight: '24px', minWidth: 0 }, style)}
    icon={icon ? cloneElement(icon, { style: R.merge({ width: '16px', fontSize: '14px', margin: '0 2px' }, R.path(['props', 'style'], icon)) }) : icon}
    {...extraProps}
  />
);

export const SmallRaisedButton = ({ style, labelStyle, icon, ...extraProps }) => (
  <RaisedButton
    labelStyle={R.merge({ textTransform: 'none', padding: '2px 4px', lineHeight: '24px', fontSize: '14px', bottom: '1px' }, labelStyle)}
    style={R.merge({ height: '24px', lineHeight: '24px', minWidth: 0 }, style)}
    icon={icon ? cloneElement(icon, { style: R.merge({ width: '16px', fontSize: '14px', margin: '0 2px', position: 'relative' }, R.path(['props', 'style'], icon)) }) : icon}
    {...extraProps}
  />
);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/small-buttons.jsx